import React from 'react';
import { useLanguage } from '../i18n';

const HelpPopup = ({ onClose }) => {
  const { t } = useLanguage();

  const helpContent = {
    sv: {
      title: "Verktygshjälp",
      tools: [
        {
          name: "Mätverktyg",
          description: "Klicka för att mäta avstånd och områden på kartan. Dubbelklicka för att avsluta mätningen.",
          icon: "📏",
          image: null
        },
        {
          name: "Zoomverktyg", 
          description: "Använd mushjulet eller +/- knapparna för att zooma in och ut på kartan.",
          icon: "🔍",
          image: null
        },
        {
          name: "Lagerpanel",
          description: "Växla mellan olika bakgrundslager och visa/dölj informationslager.",
          icon: "📋",
          image: null
        },
        {
          name: "GeoJSON Import/Export",
          description: "Ladda upp GeoJSON-filer för analys eller exportera dina data.",
          icon: "📁",
          image: null
        },
        {
          name: "Flygplatsval",
          description: "Välj en flygplats från listan för att zooma till dess position och visa relaterade data.",
          icon: "✈️",
          image: null
        },
        {
          name: "Koordinatinmatning",
          description: "Mata in koordinater manuellt för att skapa objekt. Stödjer DD.dddddd, DDMM.MMMM och DDMMSS.ssss format.",
          icon: "📍",
          image: null
        }
      ]
    },
    en: {
      title: "Tool Help",
      tools: [
        {
          name: "Measurement Tool",
          description: "Click to measure distances and areas on the map. Double-click to finish measuring.",
          icon: "📏", 
          image: null
        },
        {
          name: "Zoom Tool",
          description: "Use mouse wheel or +/- buttons to zoom in and out on the map.",
          icon: "🔍",
          image: null
        },
        {
          name: "Layer Panel", 
          description: "Switch between different background layers and show/hide information layers.",
          icon: "📋",
          image: null
        },
        {
          name: "GeoJSON Import/Export",
          description: "Upload GeoJSON files for analysis or export your data.",
          icon: "📁",
          image: null
        },
        {
          name: "Airport Selection",
          description: "Select an airport from the list to zoom to its location and display related data.",
          icon: "✈️",
          image: null
        },
        {
          name: "Coordinate Input",
          description: "Enter coordinates manually to create objects. Supports DD.dddddd, DDMM.MMMM and DDMMSS.ssss formats.",
          icon: "📍",
          image: null
        }
      ]
    }
  };

  const { language } = useLanguage();
  const help = helpContent[language];

  return (
    <div className="popup-overlay">
      <div className="popup-content help-popup">
        <div className="popup-header">
          <h2>{help.title}</h2>
          <button className="popup-close" onClick={onClose}>×</button>
        </div>
        <div className="popup-body">
          <div className="tools-grid">
            {help.tools.map((tool, index) => (
              <div key={index} className="tool-item">
                <div className="tool-icon">
                  {tool.image ? (
                    <img src={tool.image} alt={tool.name} />
                  ) : (
                    <span className="icon-placeholder">{tool.icon}</span>
                  )}
                </div>
                <div className="tool-content">
                  <h3>{tool.name}</h3>
                  <p>{tool.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="popup-footer">
          <button className="btn-primary" onClick={onClose}>
            {t('close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpPopup;